import { useEffect, useState } from 'react';
import type { Question } from '@/types/question-types';

/**
 * Route-level prefetching hook for MathLive
 * Loads MathLive in the background when quiz contains math questions
 * Provides zero-lag UX by prefetching during quiz initialization
 */
export function useMathLivePrefetch(questions: Question[]) {
  const [mathLiveReady, setMathLiveReady] = useState(false);

  useEffect(() => {
    // Check if any questions are math type
    const hasMathQuestions = questions.some(q => q.question_type === 'math');

    if (hasMathQuestions && !mathLiveReady) {
      // Prefetch MathLive in background (200-800ms)
      // This happens during quiz load while user reads instructions
      // Note: CSS is loaded automatically by MathLive
      import('mathlive')
        .then(() => {
          setMathLiveReady(true);
          console.log('MathLive prefetched and ready');
        })
        .catch((error) => {
          console.error('Failed to prefetch MathLive:', error);
        });
    } else if (!hasMathQuestions) {
      // No math questions, mark as ready (won't be used anyway)
      setMathLiveReady(true);
    }
  }, [questions, mathLiveReady]);

  return mathLiveReady;
}
